// Questi devono corrispondere, IN ORDINE, agli attributi della classe "ReportEvent"
export const xlsxColumns_event: string[][] = [
  [
    'Nome Evento',
    'Data/Ora Prenotazione',
    'Data/Ora Evento',
    'Nome Passeggero',
    'Numero di Prenotazione',
    'Numero di Badge',
    'Numero Cabina',
    'Partecipanti',
    'Check-in',
    'Stato',
  ],
];

// Questi devono corrispondere ai nomi di matColumnDef nella tabella
export const displayedColumns_event: string[] = [
  'nome_evento',
  'data_prenotazione',
  'data_evento',
  'nome_passeggero',
  'numero_prenotazione',
  'numero_badge',
  'numero_cabina',
  'numero_partecipanti',
  'check_in',
  'status',
];
